export interface Location {
    id: number,
    idParent: number,
    name: string,
    orderIndex: number,
    qr: string,
    companyProfileUuid: string,
  }

export const initialLocationsState = {
    locations: [],
};
  
export interface ILocationsState {
    locations: Location[],
}
  